import { render } from "./ClosingBalanceList.vue?vue&type=template&id=939fa73c&scoped=true"
import script from "./ClosingBalanceList.vue?vue&type=script&lang=js"
export * from "./ClosingBalanceList.vue?vue&type=script&lang=js"

import "./ClosingBalanceList.vue?vue&type=style&index=0&id=939fa73c&scoped=true&lang=css"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-939fa73c"]])

export default __exports__